import React from 'react';


const NavContext = React.createContext({
  navIsOpen: false
});

export {NavContext};
